
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { Warning, WarningOutlined } from "@material-ui/icons";
import React from "react";


export const WarningPage = () => {

    const containerStyle = {
        height: "100vh", 
        backgroundColor: "#f5f5f5", 
    };

    function setNewTheme(): void {
        localStorage.setItem("theme", "1");
        window.location.reload()
    
    }

    return (

<Grid
            container
            direction="row"
            style={containerStyle}
            justifyContent="center" 
            alignItems="center" 
        >
            
            
            
            <Grid item xs={10} sm={8} md={6} style={{ textAlign: "center" }}>
                
                <img
                src="warning.png"
                alt="Example"
                style={{ width: "50%", borderRadius: "8px", height: '50%', }}
            />
            <br/>
            <br/>
                <Typography variant="h4" style={{ fontSize: '20px', fontWeight: 'bold', lineHeight: '1.8', letterSpacing: '0.5px' }}>
                 Data migration is currently in progress. Please check back in an hour. Thank you for your patience.
                </Typography>
                <br></br>


                <Button
                    variant="contained"
                    color="primary"
                    style={{ backgroundColor: "#3f51b5", color: "#fff" }}
                    onClick={() =>setNewTheme()}
                        >Continue to US Data</Button>
        
            </Grid>
        </Grid>

    );
};
